import {Conversation, AgentCall} from '@stripe-internal/conversations-client';
import {PlanCard} from './PlanCard';
import {PaymentLinkCard} from './PaymentLinkCard';
import {ProductCard} from './ProductCard';
import {CustomerCard} from './CustomerCard';
import {ChargeCard} from './ChargeCard';
import {RefundCard} from './RefundCard';
import {PaymentIntentCard} from './PaymentIntentCard';
import {CouponCard} from './CouponCard';

const SINGLE_PAYMENT_LINK_TOOL_NAMES = [
  'update_payment_link',
  'create_payment_link',
  'retrieve_payment_link',
];
const MULTIPLE_PAYMENT_LINK_TOOL_NAMES = ['list_payment_links'];
const SINGLE_PRODUCT_TOOL_NAMES = [
  'update_product',
  'create_product',
  'retrieve_product',
];
const MULTIPLE_PRODUCT_TOOL_NAMES = ['search_products'];
const SINGLE_CUSTOMER_TOOL_NAMES = [
  'update_customer',
  'create_customer',
  'retrieve_customer',
];
const MULTIPLE_CUSTOMER_TOOL_NAMES = ['search_customers'];
const SINGLE_PRICE_TOOL_NAMES = ['update_price', 'create_price'];
const MULTIPLE_PRICE_TOOL_NAMES = ['search_prices'];
const SINGLE_CHARGE_TOOL_NAMES = ['create_charge', 'retrieve_charge'];
const MULTIPLE_CHARGE_TOOL_NAMES = ['search_charges'];
const SINGLE_PAYMENT_INTENT_TOOL_NAMES = [
  'create_payment_intent',
  'retrieve_payment_intent',
  'update_payment_intent',
];
const MULTIPLE_PAYMENT_INTENT_TOOL_NAMES = ['list_payment_intents'];
const SINGLE_REFUND_TOOL_NAMES = [
  'create_refund',
  'retrieve_refund',
  'update_refund',
];
const MULTIPLE_REFUND_TOOL_NAMES = ['list_refunds'];
const SINGLE_COUPON_TOOL_NAMES = [
  'create_coupon',
  'retrieve_coupon',
  'update_coupon',
];
const MULTIPLE_COUPON_TOOL_NAMES = ['list_coupons'];

type AgentCardProps = {
  agentCall: AgentCall;
  conversation: Conversation;
  messageId: string;
};

export const AgentCard = ({
  agentCall,
  conversation,
  messageId,
}: AgentCardProps) => {
  const {tool_name: toolName, response} = agentCall;

  if (toolName === 'generate_new_or_updated_plan') {
    return (
      <PlanCard
        agentCallResponse={response}
        conversation={conversation}
        messageId={messageId}
      />
    );
  } else if (SINGLE_PAYMENT_LINK_TOOL_NAMES.includes(toolName)) {
    return <PaymentLinkCard agentCallResponse={response} />;
  } else if (
    SINGLE_PRODUCT_TOOL_NAMES.includes(toolName) ||
    SINGLE_PRICE_TOOL_NAMES.includes(toolName)
  ) {
    return <ProductCard agentCallResponse={response} />;
  } else if (SINGLE_CHARGE_TOOL_NAMES.includes(toolName)) {
    return <ChargeCard agentCallResponse={response} />;
  } else if (SINGLE_PAYMENT_INTENT_TOOL_NAMES.includes(toolName)) {
    return <PaymentIntentCard agentCallResponse={response} />;
  } else if (SINGLE_REFUND_TOOL_NAMES.includes(toolName)) {
    return <RefundCard agentCallResponse={response} />;
  } else if (
    MULTIPLE_PAYMENT_LINK_TOOL_NAMES.includes(toolName) &&
    Array.isArray(response) &&
    response.length === 1
  ) {
    return <PaymentLinkCard agentCallResponse={response[0]} />;
  } else if (
    MULTIPLE_PRODUCT_TOOL_NAMES.includes(toolName) &&
    Array.isArray(response) &&
    response.length === 1
  ) {
    return <ProductCard agentCallResponse={response[0]} />;
  } else if (SINGLE_CUSTOMER_TOOL_NAMES.includes(toolName)) {
    return <CustomerCard agentCallResponse={response} />;
  } else if (
    SINGLE_COUPON_TOOL_NAMES.includes(toolName) &&
    response.promotion_code
  ) {
    return <CouponCard agentCallResponse={response} />;
  } else if (
    MULTIPLE_CUSTOMER_TOOL_NAMES.includes(toolName) &&
    Array.isArray(response) &&
    response.length === 1
  ) {
    return <CustomerCard agentCallResponse={response[0]} />;
  } else if (
    MULTIPLE_PRICE_TOOL_NAMES.includes(toolName) &&
    Array.isArray(response) &&
    response.length === 1
  ) {
    return <ProductCard agentCallResponse={response[0]} />;
  } else if (
    MULTIPLE_CHARGE_TOOL_NAMES.includes(toolName) &&
    Array.isArray(response) &&
    response.length === 1
  ) {
    return <ChargeCard agentCallResponse={response[0]} />;
  } else if (
    MULTIPLE_PAYMENT_INTENT_TOOL_NAMES.includes(toolName) &&
    Array.isArray(response) &&
    response.length === 1
  ) {
    return <PaymentIntentCard agentCallResponse={response[0]} />;
  } else if (
    MULTIPLE_REFUND_TOOL_NAMES.includes(toolName) &&
    Array.isArray(response) &&
    response.length === 1
  ) {
    return <RefundCard agentCallResponse={response[0]} />;
  } else if (
    MULTIPLE_COUPON_TOOL_NAMES.includes(toolName) &&
    Array.isArray(response) &&
    response.length === 1
  ) {
    return <CouponCard agentCallResponse={response[0]} />;
  }
};
